export default __webpack_public_path__ + "static/media/GHSI Regular Board Minutes 11 October 2022.cc7150d2.pdf";